import * as React from "react";
import Spinner from "../Spinner/index";
import { LoadingContainerProps } from "../types";
import styles from "./index.module.css";

function LoadingContainer(props: LoadingContainerProps) {
  return (
    <div className={styles.container}>
      <div aria-hidden={!props.isBusy}>
        <Spinner />
      </div>
      <div aria-busy={props.isBusy}>{props.children}</div>
    </div>
  );
}

export default LoadingContainer;
